import { HStack, Text, Button } from '@chakra-ui/react';
import ContentContainer from '~/containers/Content';

import modalControlAtom from '~/recoil/atom/modalControl';
import { useSetRecoilState } from 'recoil';

export default function FooterLoginSection() {
  const setModalControl = useSetRecoilState(modalControlAtom);

  return (
    <ContentContainer bottom={0} transition="0.3s">
      <HStack justify="space-between" px={4} py={2} bg="secondary" spacing={1}>
        <HStack>
          <Text color="white" fontSize="md">
            登入後才可下單
          </Text>
        </HStack>
        <Button
          variant="unstyled"
          color="white"
          bg="neutral"
          w="9.6rem"
          onClick={() => setModalControl((prev) => ({ ...prev, isLoginModalOpen: true }))}
        >
          登入
        </Button>
      </HStack>
    </ContentContainer>
  );
}
